module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0117.jpg?v=8905d8e7";